var EliteSummonConst =  {}

EliteSummonConst.ActivityID = {
	elite_summon_1 : 34001,
	elite_summon_2 : 36017,
	elite_summon_3 : 39014,
}

module.exports = EliteSummonConst